/**
 * TechDocLink — Renders a download link for a product's technical PDF.
 * Returns null if no pdfUrl is provided.
 *
 * Props:
 *   pdfUrl      — string (URL to PDF, can be null/undefined)
 *   productName — string
 */
export default function TechDocLink({ pdfUrl, productName }) {
  if (!pdfUrl) return null;

  return (
    <a
      href={pdfUrl}
      target="_blank"
      rel="noopener noreferrer"
      className="flex items-center gap-2 text-electric-blue hover:underline font-sandvik-text py-3 px-4 bg-n1 mb-4"
      download
    >
      <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth={2}
          d="M12 10v6m0 0l-3-3m3 3l3-3m2 8H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z"
        />
      </svg>
      <span>Download technical specifications</span>
    </a>
  );
}
